import ajax from "./ajax";

// Neck-label library: saved per-size label sets and the bulk "Neck label"
// job on Products and Listings. Node API: routes/neckLabels.js.

/** { hasNeckLabels } — whether Settings → Neck labels should show. */
export const getNeckLabelStatus = () => ajax("/neck-labels/status");

export const listNeckLabelSets = (params = {}) =>
  ajax("/neck-labels/sets", {
    query: params.ownerUid ? { ownerUid: params.ownerUid } : undefined,
  });

export const createNeckLabelSet = (data) =>
  ajax("/neck-labels/sets", { method: "POST", data });

export const updateNeckLabelSet = (setId, data) =>
  ajax(`/neck-labels/sets/${encodeURIComponent(setId)}`, { method: "PUT", data });

export const deleteNeckLabelSet = (setId) =>
  ajax(`/neck-labels/sets/${encodeURIComponent(setId)}`, { method: "DELETE" });

/** { summaries: { [id]: { state, setId?, setName? } } } — kind "product" | "listing". */
export const getNeckLabelSummaries = (kind, ids) =>
  ajax("/neck-labels/summaries", { method: "POST", data: { kind, ids } });

export const preflightNeckLabelJob = (data) =>
  ajax("/neck-labels/jobs/preflight", { method: "POST", data, timeout: 120000 });

export const startNeckLabelJob = (data) =>
  ajax("/neck-labels/jobs", { method: "POST", data });

export const listActiveNeckLabelJobs = () =>
  ajax("/neck-labels/jobs", { query: { active: "true" } });

export const getNeckLabelJob = (jobId) => ajax(`/neck-labels/jobs/${jobId}`);

export const getNeckLabelJobResults = (jobId, statuses = []) =>
  ajax(`/neck-labels/jobs/${jobId}/results`, {
    query: statuses.length ? { status: statuses.join(",") } : undefined,
  });

export const cancelNeckLabelJob = (jobId) =>
  ajax(`/neck-labels/jobs/${jobId}/cancel`, { method: "POST", data: {} });

export const retryFailedNeckLabelJob = (jobId) =>
  ajax(`/neck-labels/jobs/${jobId}/retry-failed`, { method: "POST", data: {} });

export const dismissNeckLabelJob = (jobId) =>
  ajax(`/neck-labels/jobs/${jobId}/dismiss`, { method: "POST", data: {} });
